import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  canonical, 
  ogImage,
  ogTitle,
  ogDescription,
  ogType = 'website',
  noIndex = false,
  jsonLd = null
}) => {
  const siteName = 'EasyMyVisa';
  const defaultDescription = 'Fast, secure, and hassle-free visa processing at your fingertips. Apply for tourist, business, work, and student visas to 150+ countries.';
  const defaultImage = '/og-image.png';
  const baseUrl = window.location.origin;

  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} - Simplifying Visa Applications Worldwide`;
  const metaDescription = description || defaultDescription;
  const metaImage = ogImage || `${baseUrl}${defaultImage}`;
  const canonicalUrl = canonical ? `${baseUrl}${canonical}` : window.location.href;
  const metaOgTitle = ogTitle || fullTitle;
  const metaOgDescription = ogDescription || metaDescription;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonicalUrl} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:title" content={metaOgTitle} />
      <meta property="og:description" content={metaOgDescription} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:site_name" content={siteName} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metaOgTitle} />
      <meta name="twitter:description" content={metaOgDescription} />
      <meta name="twitter:image" content={metaImage} />

      {/* JSON-LD Structured Data */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
